import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/adquisiciones/notas-entrada/crear', documento: 'adquisiciones', acceso: 'sesion', filas: ['050'],
  cita: 'Areas/Adquisiciones/Controllers/NotasEntradaController.cs',
} satisfies RutaProd;
